import { useCallback, useReducer } from 'react';
import { createHistory, reduceHistory } from '@/lib/history';

export function useDocumentHistory<T>(initial: T) {
  const [history, dispatch] = useReducer(reduceHistory<T>, initial, createHistory<T>);
  const update = useCallback(
    (change: (previous: T) => T, options?: { record?: boolean; group?: string }) => {
      dispatch({
        type: 'update',
        update: change,
        record: options?.record ?? true,
        group: options?.group ?? null,
        now: Date.now(),
      });
    },
    [],
  );
  const undo = useCallback(() => dispatch({ type: 'undo' }), []);
  const redo = useCallback(() => dispatch({ type: 'redo' }), []);
  return {
    document: history.present,
    update,
    undo,
    redo,
    canUndo: history.past.length > 0,
    canRedo: history.future.length > 0,
  };
}
